import script from "./App.vue?vue&type=script&setup=true&lang=jsx"
export * from "./App.vue?vue&type=script&setup=true&lang=jsx"

import "./App.vue?vue&type=style&index=0&id=411463ba&lang=css"

const __exports__ = script;

export default __exports__